import type { User } from '../user';

/**
 * Canonical mock {@link User} used by tests, MSW handlers and the demo
 * build. Defaults to an `admin` user belonging to company id `1`.
 */
export const MOCK_USER: User = {
  id: 1,
  company_id: 1,
  type: 'admin',
  email: 'test@example.com',
  accept_tos: true,
  accept_no_disclose: true,
};

/**
 * Builds a {@link User} from {@link MOCK_USER} with optional overrides.
 *
 * @example
 * const supplier = createMockUser({ type: 'supplier', email: 'a@b.com' });
 */
export function createMockUser(overrides?: Partial<User>): User {
  return { ...MOCK_USER, ...overrides };
}

/**
 * Builds a list of mock {@link User}s. IDs are auto-incremented from `1`
 * unless overridden by the per-index callback.
 *
 * @param count - Number of users to generate. Defaults to `3`.
 * @param overrideAt - Optional callback invoked per-index to override fields.
 * @example
 * const users = createMockUserList(2, (i) => ({ email: `u${i}@x.com` }));
 */
export function createMockUserList(
  count = 3,
  overrideAt?: (index: number) => Partial<User>
): User[] {
  return Array.from({ length: count }, (_, i) =>
    createMockUser({ id: i + 1, ...overrideAt?.(i) })
  );
}
